import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const CANONICAL_ORIGIN = "https://behireready.in";
const PAGE_META = {
  "/privacy": {
    title: "Privacy Policy | Be Hire Ready",
    description: "How Be Hire Ready collects, uses and protects data submitted through career-readiness enquiry forms.",
  },
  "/terms": {
    title: "Terms & Conditions | Be Hire Ready",
    description: "Terms of use for Be Hire Ready's career-readiness training programs and services.",
  },
};

export default function Legal({ title, children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = PAGE_META[pathname] || { title: `${title} | Be Hire Ready`, description: "" };
    document.title = meta.title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    setMeta("description", meta.description);
    setMeta("robots", "index, follow");
    setLink("canonical", `${CANONICAL_ORIGIN}${pathname}`);
    setMeta("og:title", meta.title, "property");
    setMeta("og:description", meta.description, "property");
    setMeta("og:url", `${CANONICAL_ORIGIN}${pathname}`, "property");
    setMeta("og:type", "article", "property");
  }, [pathname, title]);

  return (
    <div className="min-h-screen bg-white">
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
        <Link to="/" className="text-sm text-slate-500 hover:text-[#0B132B]">← Back home</Link>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl text-[#0B132B]">{title}</h1>
        <div className="mt-6 prose prose-slate max-w-none text-slate-700 leading-relaxed">
          {children}
        </div>
      </main>
    </div>
  );
}
